export const Role = {
  Administrator: 1,
  LeadBroker: 2,
  Broker: 3,
  Contact: 4,
} as const;

export type RoleType = (typeof Role)[keyof typeof Role];
